const initialState = {
	isOpen: false,
	isDirty: false,
	isLoading: false,
	isProcessing: false,
	isProcessed: false,
	isSuccessful: false,
	isUnsuccessful: false,
	isSaved: false,
	hasError: false,
	isUploading: false,
	uploadProgress: 100,
	activeTab: 'items',
	errorMessage: '',
	itemsLoaded: false,
	publicItemsById: {},
	userItemsById: {},
	selected: false,
	selectedGroup: false,
	isGallery: false
}

function removeKeyFromObject( deleteKey, obj ) {
	return Object.keys( obj )
		.filter( key => key !== deleteKey )
		.reduce( ( result, current ) => {
			result[ current ] = obj[ current ]

			return result
		}, {} )
}

export default function reducer( state = initialState, action ) {
	const { payload } = action
	let selectedGroup

	switch ( action.type ) {
		case 'CLOSE_MEDIA_LIBRARY':
			return {
				...state,
				isOpen: false,
				isDirty: false,
				isLoading: false,
				isProcessing: false,
				isProcessed: false,
				isSuccessful: false,
				isUnsuccessful: false,
				isSaved: false,
				hasError: false,
				isUploading: false,
				uploadProgress: 100,
				activeTab: 'items',
				errorMessage: '',
				selected: false,
				selectedGroup: false,
				isGallery: false
			}

		case 'SET_LIBRARY_TAB':
			return {
				...state,
				activeTab: payload.id
			}

		case 'SET_LIBRARY_ITEMS_DATA':
			return {
				...state,
				itemsLoaded: true,
				publicItemsById: payload.data.public,
				userItemsById: payload.data.user
			}

		case 'ADD_LIBRARY_ITEMS_DATA':
			let newItemsById
			let selected = false

			if ( payload.data.can_be_edited ) {
				newItemsById = {
					...state.userItemsById
				}
			} else {
				newItemsById = {
					...state.publicItemsById
				}
			}

			if ( newItemsById[ 'id_' + payload.data.id ] ) {
				// Update an existing item:
				newItemsById[ 'id_' + payload.data.id ] = payload.data
			} else {
				// New item: place in top position:
				newItemsById = {
					[ 'id_' + payload.data.id ]: payload.data,
					...newItemsById
				}
			}

			if ( state.selected ) {
				selected = payload.data
			}

			if ( payload.data.can_be_edited ) {
				return {
					...state,
					selected: selected,
					userItemsById: newItemsById
				}
			} else {
				return {
					...state,
					selected: selected,
					publicItemsById: newItemsById
				}
			}

		case 'REMOVE_LIBRARY_ITEM':
			// let selected = state.selected == payload ? false : state.selected
			let removedKey = 'id_' + payload

			return {
				...state,
				selected: false,

				userItemsById: Object.keys( state.userItemsById ).reduce( ( result, key ) => {
					if ( key != removedKey ) {
						result[ key ] = state.userItemsById[ key ]
					}

					return result
				}, {} )
			}

		case 'SELECT_ITEM':
			return {
				...state,
				selected: payload
			}

		case 'UNSELECT_ITEM':
			return {
				...state,
				selected: false
			}

		case 'SELECT_GROUP_ITEM':
			return {
				...state,
				selectedGroup: {
					...state.selectedGroup,
					[ 'id_' + payload.id ]: {
						...payload
					}
				}
			}

		case 'UNSELECT_GROUP_ITEM':
			selectedGroup = removeKeyFromObject( 'id_' + payload.id, state.selectedGroup )

			return {
				...state,
				selectedGroup: selectedGroup
			}

		case 'SET_GALLERY_MODE':
			selectedGroup = state.selectedGroup

			if ( ! payload ) {
				selectedGroup = false
			}

			return {
				...state,
				isGallery: payload,
				selectedGroup: selectedGroup
			}

		case 'SET_MEDIA_UPLOADING_STATE':
			return {
				...state,
				isUploading: payload
			}

		case 'SET_MEDIA_UPLOAD_PROGRESS':
			return {
				...state,
				uploadProgress: payload
			}

		case 'SET_LIBRARY_PROCESSING':
			return {
				...state,
				isProcessing: true,
				isProcessed: false
			}

		case 'SET_LIBRARY_PROCESSED':
			return {
				...state,
				isProcessed: true
			}

		case 'RECEIVE_LIBRARY_UPDATE_RESPONSE':
			return {
				...state,
				isSaved: true,
				isDirty: false,
				isSuccessful: true
			}

		case 'RECEIVE_LIBRARY_UPDATE_ERROR':
			return {
				...state,
				hasError: true,
				isUnsuccessful: true,
				isSaving: false
			}

		case 'UNSET_LIBRARY_PROCESSED':
			return {
				...state,
				isProcessed: false,
				isProcessing: false,
				isSuccessful: false,
				isUnsuccessful: false,
				isSaved: false
			}
	}

	return state
}



// WEBPACK FOOTER //
// ./redux/reducers/media.jsx